import React from 'react';
import CheckCircleOutlineOutlinedIcon from '@material-ui/icons/CheckCircleOutlineOutlined';
import { makeStyles } from '@material-ui/core/styles';
import AppBarMenuItem from './AppBarMenuItem';
import { fontColors } from '../material-ui-theme';
import { useDispatch, useSelector } from 'react-redux';
import { getIsDarkTheme } from '../reducers';
import { toggleTheme } from '../actions/theme';

const useStyles = makeStyles(() => ({
  root: {
    '& svg': {
      fill: fontColors.disabled,
      '&.enabled': {
        fill: 'var(--color-colorPrimary-main)',
      },
    },
  },
}));

const DarkThemeToggle = () => {
  const dispatch = useDispatch();
  const isDarkTheme = useSelector(getIsDarkTheme) || false;
  const classes = useStyles();

  const toggleDarkTheme = () => {
    dispatch(toggleTheme());
  };

  return (
    <AppBarMenuItem
      title="Dark Theme"
      onClick={toggleDarkTheme}
      icon={
        <CheckCircleOutlineOutlinedIcon
          className={`${isDarkTheme ? 'enabled' : ''}`}
        />
      }
      className={classes.root}
    />
  );
};

export default DarkThemeToggle;
